import getGraficoMensualData from "./getGraficoMensualData";
import getGraficoDiarioData from "./getGraficoDiarioData";
import getReporte from "./getReporte";
export default {
    getGraficoMensualData,
    getGraficoDiarioData,
    getReporte,
}
